import * as Cesium from '@cesiumgs/cesium-analytics'

function word2Lnglat(viewer: Cesium.Viewer, postions: any) {
  const ellipsoid = viewer.scene.globe.ellipsoid
  const lnglatArr: any = []
  postions.forEach((item: any) => {
    const cartographic = ellipsoid.cartesianToCartographic(item)
    const lat = Cesium.Math.toDegrees(cartographic.latitude)
    const lng = Cesium.Math.toDegrees(cartographic.longitude)
    lnglatArr.push([lng, lat])
  })
  return lnglatArr
}

async function getPositionDistance(positions: any, cesiumview: Cesium.Viewer) {
  let distance = 0
  for (let i = 0; i < positions.length - 1; i++) {
    const point1cartographic = positions[i]
    const point2cartographic = positions[i + 1]
    const data = await getTerrainDistance(
      point1cartographic,
      point2cartographic,
      cesiumview,
    )
    distance = distance + Number(data) + 60
  }
  return distance.toFixed(3)
}

function getTerrainDistance(start: any, end: any, cesiumview: any) {
  return new Promise((resolve) => {
    const lerpArray = []
    const splitNum = Cesium.Cartesian3.distance(start, end)
    const startCartographic = Cesium.Cartographic.fromCartesian(start)
    const startDegrees = [
      startCartographic.longitude,
      startCartographic.latitude,
    ]
    const endCartographic = Cesium.Cartographic.fromCartesian(end)
    const endDegrees = [endCartographic.longitude, endCartographic.latitude]
    lerpArray.push(new Cesium.Cartographic(startDegrees[0], startDegrees[1]))
    for (let i = 1; i <= splitNum - 1; i++) {
      const x = Cesium.Math.lerp(startDegrees[0], endDegrees[0], i / splitNum)
      const y = Cesium.Math.lerp(startDegrees[1], endDegrees[1], i / splitNum)
      lerpArray.push(new Cesium.Cartographic(x, y))
    }
    Cesium.sampleTerrainMostDetailed(
      cesiumview.terrainProvider,
      lerpArray,
    ).then((cartographicArr) => {
      getDetailedTerrainDistance(cartographicArr).then((distance) => {
        resolve(distance)
      })
    })
  })
}

function getDetailedTerrainDistance(cartographicArr: any) {
  return new Promise((resolve) => {
    let terrainDistance = 0
    cartographicArr.forEach((currentCartographic: any, index: number) => {
      if (index === cartographicArr.length - 1) {
        return
      }
      const nextCartographic = cartographicArr[index + 1]
      const currentPosition = Cesium.Cartesian3.fromRadians(
        currentCartographic.longitude,
        currentCartographic.latitude,
        currentCartographic.height,
      )
      const nextPosition = Cesium.Cartesian3.fromRadians(
        nextCartographic.longitude,
        nextCartographic.latitude,
        nextCartographic.height,
      )
      terrainDistance += Cesium.Cartesian3.distance(
        currentPosition,
        nextPosition,
      )
    })
    resolve(terrainDistance)
  })
}

export {
  word2Lnglat,
  getPositionDistance,
}
